<template>
  <div class="hover-shadow box-border-7"
    v-if = "callHistory.callId"
    >
    <!-- 呼叫信息 -->
    <div>
      <span>{{value}}</span>
    </div>

    <div>
      <span>{{callHistory.caller}} {{'0' == callHistory.callType ? '呼入' : '呼出'}} {{callHistory.called}}</span>
    </div>

    <div>
      <span>{{timeFrom}} - {{timeDiff}} - {{timeTo}}</span>
    </div>

    <audio style="height:25px;" controls preload="meta" :src="callHistory.recordUrl"></audio>

    <!-- 客户信息 -->
    <div>
      <b>客户姓名:</b>
      <span>{{callCustomer.name}}</span>
    </div>
    <div>
      <b>电话:</b>
      <span>{{callCustomer.phone}}</span>
    </div>
    <div>
      <b>地址:</b>
      <span>{{callCustomer.address}}</span>
    </div>
    <div>
      <b>备注:</b>
      <span>{{callCustomer.memo}}</span>
    </div>
    <div>
      <b>公司:</b>
      <span>{{callCustomer.company}}</span>
    </div>
  </div>

  <el-input
    v-else
    placeholder="工单关联的当次呼叫信息"
    v-model="value"
    style="width:100%;"/>
</template>

<script>
export default {
  name: "TicketWidgetCallInfo",

  props: ["value"],

  computed: {
      timeFrom() {
          if ( !this.callHistory.timeFrom ) {
              return '';
          }

          return this.callHistory.timeFrom.replace('2019-', '19-').replace('2020-', '');
      },

      timeTo() {
          if ( !this.callHistory.timeTo ) {
              return '';
          }

          return this.callHistory.timeTo.replace('2019-', '19-').replace('2020-', '');
      },

      timeDiff() {
          if ( !this.callHistory.timeTo || !this.callHistory.timeFrom ) {
              return '';
          }

          var _to = new Date(this.callHistory.timeTo.replace(/-/g, "/")).getTime();
          var _from = new Date(this.callHistory.timeFrom.replace(/-/g, "/")).getTime();

          return '' + ( _to - _from ) / 1000 + 'S'
      }
  },

  data() {
    return {
      callCustomer: {},
      callHistory: {}
    };
  },

  watch: {
    value() {
      this.onValueChange();
    }
  },

  methods: {
    onValueChange() {
      if (!this.value) {
        // console.log("#22 TicketWidgetCallInfo onValueChange", this);
        return;
      }

      this.loadCallCustomer();

      this.loadCallHistory();
    },

    loadCallCustomer() {
      var _this = this;

      sdk.TicketCallCustomerApi().findByCallId({
          callId: _this.value
        }).then(res => {
          _this.callCustomer = res || {};
        });
    },

    loadCallHistory() {
      var _this = this;

      sdk.TicketCallHistoryApi().findByCallId({
          callId: _this.value
        }).then(res => {
          _this.callHistory = res || {};
        });
    }
  },

  mounted() {
    this.onValueChange();
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketWidgetCallInfo.vue